import React from "react"
import PropTypes from "prop-types"

import { Icon } from "@/components"
import { EnumSelectCell } from "app/static/frontend/sheets/components/cells/MantineCells/EnumSelectCell"
import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"
import { createStyles } from "@mantine/core"

const useStyles = createStyles((theme) => ({
    thumbsUp: {
        color: `${theme.colors.green[6]}`,
    },
    thumbsDown: {
        color: `${theme.colors.red[5]}`,
    },
    neutral: {
        color: `${theme.colors.gray[7]}`,
    },
}))

export const ThumbsUpDownNeutralCell = ({ children, ...props }) => {
    const item = DjangIO.app.userdata.spreadsheet.types.ThumbType.by_value(Number(children))
    // Ooph
    const icon = item?.icon?.replace("fa-", "")?.replace("-o", "")
    const { classes } = useStyles()
    if (props.editing) {
        return (
            <EnumSelectCell
                className="enumSelectCell"
                choices={DjangIO.app.userdata.spreadsheet.types.ThumbType}
                item={item}
                clearable
                {...props}
            />
        )
    } else {
        return (
            <CellWrapper center className="cell" {...props}>
                {typeof children === "number" && (
                    <Icon
                        className={
                            item === DjangIO.app.userdata.spreadsheet.types.ThumbType.thumbs_up
                                ? classes.thumbsUp
                                : item === DjangIO.app.userdata.spreadsheet.types.ThumbType.thumbs_down
                                  ? classes.thumbsDown
                                  : classes.neutral
                        }
                        icon={icon}
                        size="lg"
                    />
                )}
            </CellWrapper>
        )
    }
}

ThumbsUpDownNeutralCell.propTypes = {
    children: PropTypes.number,
}

export default ThumbsUpDownNeutralCell
